export default __webpack_public_path__ + "static/media/team-hero-mobile.bb1ee153.png";